import * as i0 from '@angular/core';
import { Component, ViewChild, Input, NgModule } from '@angular/core';

class SignatureSettings {
    constructor() {
        this.ownerName = '';
        this.signatureBoxName = 'txsign';
        this.signerName = '';
        this.signerInitials = '';
        this.showSignatureBar = false;
        this.uniqueId = '';
        this.redirectUrlAfterSignature = '';
        this.signatureBoxes = null;
    }
}

class ViewerSettings {
    constructor(basePath = '') {
        this.basePath = basePath;
        this.toolbarDocked = true;
        this.documentPath = '';
        this.documentData = '';
        this.isSelectionActivated = true;
        this.signatureSettings = new SignatureSettings();
        this.showThumbnailPane = false;
        this.dock = 0;
        this.resources = null;
        this.userNames = [];
    }
    static dockFromString(value) {
        switch (value) {
            case 'Window': return 0;
            case 'Fill': return 1;
        }
        return 0;
    }
}

class DocumentViewerComponent {
    constructor(hostElement) {
        this.hostElement = hostElement;
        this.basePath = DocumentViewerComponent.DefaultSettings.basePath;
        this.dock = 'Fill';
        this.documentData = DocumentViewerComponent.DefaultSettings.documentData;
        this.documentPath = DocumentViewerComponent.DefaultSettings.documentPath;
        this.isSelectionActivated = DocumentViewerComponent.DefaultSettings.isSelectionActivated;
        this.showThumbnailPane = DocumentViewerComponent.DefaultSettings.showThumbnailPane;
        this.signatureSettings = DocumentViewerComponent.DefaultSettings.signatureSettings;
        this.toolbarDocked = DocumentViewerComponent.DefaultSettings.toolbarDocked;
        this.resources = DocumentViewerComponent.DefaultSettings.resources;
        this.userNames = DocumentViewerComponent.DefaultSettings.userNames;
    }
    ngOnInit() {
        window['Zone'].root.run(() => {
            // include script tag
            let elemScript = document.createElement('script');
            elemScript.type = 'application/javascript';
            var queryStringBasePath = this.basePath.split('?');
            var queryStringBasePathExtension = "";
            if (queryStringBasePath.length > 1) {
                queryStringBasePathExtension = "&" + queryStringBasePath[1];
            }
            this.basePath = queryStringBasePath[0];
            elemScript.setAttribute('src', queryStringBasePath[0] + '/TextControl/GetResource?Resource=minimized.tx-viewer.min.js' + queryStringBasePathExtension);
            this.containerDiv.nativeElement.appendChild(elemScript);
            let elemInitialScript = document.createElement('script');
            elemInitialScript.type = 'application/javascript';
            elemInitialScript.innerText = 'window.onload = function () { if (typeof TXDocumentViewer  === "undefined") { console.log(\"Document Viewer backend cannot be reached. Please make sure that the backend defined through the basePath property is running.\"); } else { TXDocumentViewer.init({ containerID: \"txViewer\", viewerSettings: { signatureSettings: ' + JSON.stringify(this.signatureSettings) + ', userNames: ' + JSON.stringify(this.userNames) + ', dock: ' + ViewerSettings.dockFromString(this.dock) + ', documentData: \"' + this.documentData + '\", documentPath: \"' + this.documentPath + '\", toolbarDocked: ' + this.toolbarDocked + ', isSelectionActivated: ' + this.isSelectionActivated + ', showThumbnailPane: ' + this.showThumbnailPane + ', resources: ' + JSON.stringify(this.resources) + ', basePath: "' + this.basePath + '"}}) }};';
            this.containerDiv.nativeElement.appendChild(elemInitialScript);
            // Set stuff on host element
            this.containerDiv.nativeElement.style.width = this.width;
            this.containerDiv.nativeElement.style.height = this.height;
        });
    }
    get settings() {
        let settings = new ViewerSettings(this.basePath);
        settings.basePath = this.basePath;
        settings.dock = ViewerSettings.dockFromString(this.dock);
        settings.documentData = this.documentData;
        settings.documentPath = this.documentPath;
        settings.isSelectionActivated = this.isSelectionActivated;
        settings.showThumbnailPane = this.showThumbnailPane;
        settings.signatureSettings = this.signatureSettings;
        settings.toolbarDocked = this.toolbarDocked;
        settings.resources = this.resources;
        settings.userNames = this.userNames;
        return settings;
    }
}
DocumentViewerComponent.DefaultSettings = new ViewerSettings();
DocumentViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
DocumentViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DocumentViewerComponent, selector: "tx-document-viewer", inputs: { width: "width", height: "height", basePath: "basePath", dock: "dock", documentData: "documentData", documentPath: "documentPath", isSelectionActivated: "isSelectionActivated", showThumbnailPane: "showThumbnailPane", signatureSettings: "signatureSettings", toolbarDocked: "toolbarDocked", resources: "resources", userNames: "userNames" }, viewQueries: [{ propertyName: "containerDiv", first: true, predicate: ["txViewer"], descendants: true, static: true }], ngImport: i0, template: "<div #txViewer id=\"txViewer\"></div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tx-document-viewer', template: "<div #txViewer id=\"txViewer\"></div>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { containerDiv: [{
                type: ViewChild,
                args: ['txViewer', { static: true }]
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], basePath: [{
                type: Input
            }], dock: [{
                type: Input
            }], documentData: [{
                type: Input
            }], documentPath: [{
                type: Input
            }], isSelectionActivated: [{
                type: Input
            }], showThumbnailPane: [{
                type: Input
            }], signatureSettings: [{
                type: Input
            }], toolbarDocked: [{
                type: Input
            }], resources: [{
                type: Input
            }], userNames: [{
                type: Input
            }] } });

class DocumentViewerModule {
}
DocumentViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DocumentViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerModule, declarations: [DocumentViewerComponent], exports: [DocumentViewerComponent] });
DocumentViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DocumentViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DocumentViewerComponent],
                    imports: [],
                    exports: [DocumentViewerComponent]
                }]
        }] });

/*
 * Public API Surface of tx-ng-document-viewer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DocumentViewerComponent, DocumentViewerModule };
